@if (data(); as data) {
	@if (key(); as key) {
		@if (data.after && !data.before) {
			{{ data.after[key] }}
		} @else if (
			data.after &&
			data.before &&
			data.after[key] !== null &&
			data.after[key] !== undefined &&
			data.before[key] !== null &&
			data.before[key] !== undefined &&
			data.after[key] !== data.before[key]
		) {
			<s>
				<i>{{ data.before[key] }}</i>
			</s>
			{{ data.after[key] }}
		} @else {
			{{ data.before?.[key] }}
		}
	}
}
